import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import { Cookies } from 'react-cookie'

const cookies = new Cookies();

import MainApp from './components/MainApp/MainApp'
import ListItems from './components/Items/ListItems'
import SignIn from './components/Signin/Signin';
import Dashboard from './components/Dashboard/Dashboard';
import Quotes from './components/Quotes/Quotes';
import QuotesDetail from './components/Quotes/QuotesDetail';
import VendorDetail from './components/Vendor/Detail';
import Projects from './components/Projects/Projects';
import PaymentTerm from './components/Projects/PaymentTerm';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
    <Route {...rest} render={props => (
      <Layout>
        <Component {...props} />
      </Layout>
    )} />
)

const token = cookies.get('vendor');

const PrivateRoute = ({ layout: Layout, ...rest }) => (
    <Route {...rest} render={props => (
        token
        ? (
            <Redirect to='/quotes' />
        )
        : <Redirect to='/login' />
    )} />
  )

export default () => {
    return (
        <BrowserRouter>
            <Switch>
                <PrivateRoute exact path="/" layout={MainApp} />
                <AppRoute exact path="/items" layout={MainApp} component={ListItems} />
                <AppRoute exact path="/quotes" layout={MainApp} component={Quotes} />
                <AppRoute exact path="/quotes/detail/:quote_id" layout={MainApp} component={QuotesDetail} />
                <AppRoute exact path="/profile" layout={MainApp} component={VendorDetail} />
                <AppRoute exact path="/projects" layout={MainApp} component={Projects} />
                {/* <AppRoute exact path="/quotes/detail/:quote_id" layout={MainApp} component={QuotesDetail} /> */}
                <AppRoute exact path="/projects/payment/:project" layout={MainApp} component={PaymentTerm} />
                <Route exact path="/login" component={SignIn} />
            </Switch>
        </BrowserRouter>
    )
}